import React from 'react'
import HojaMarcaciones from './HojaMarcaciones'

export default function HojaMarcacionesServidor() {
  return (
    <>
        <HojaMarcaciones
            ingresaIdentificacion = {false}
        />
    </>
  )
}
